<template>
  <div id="question-add-or-update-dialog" class="custom-modal">
    <div class="modal-body">
      <transition name="el-fade-in" mode="out-in">

      <HolaconLottie  v-if="loading == 'updateQuestionItem' && form == null" key="create-loading"  />

        <el-row key="content-loading" v-else>
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.quaestionLibrary.quaestionLibraryAddUpdate.title") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.quaestionLibrary.quaestionLibraryAddUpdate.titleMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <el-input v-model="form.title" :class="$inputError('title', validationErrors)"></el-input>
                <span class="error">{{ $errorMessage("title", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row class="mt-3 " :gutter="10">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("contentManagement.quaestionLibrary.quaestionLibraryAddUpdate.answer") }}</label>
                  <el-tooltip placement="top">
                    <div slot="content" class="custom-tooltip-content">
                      <span>{{ $t("contentManagement.quaestionLibrary.quaestionLibraryAddUpdate.answerMsg") }}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </div>
                <quill-editor @ready="onEditorReady($event)" :options="editorOption" ref="editor" v-model="form.details" :class="$inputError('details', validationErrors)" />
                <span class="error">{{ $errorMessage("details", validationErrors) }}</span>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col class="mt-2" :span="24">
              <div class="custom-section-container">
                <div class="section-header" @click="settingsDock = !settingsDock">
                  <div class="section-title">
                    <div class="section-head">
                      <label>{{ $t("contentManagement.quaestionLibrary.quaestionLibraryAddUpdate.settings") }}</label>
                      <!-- <el-tooltip content="Content" placement="bottom">
                          <i class="el-icon-info"></i>
                        </el-tooltip> -->
                    </div>
                    <span>{{ $t("contentManagement.quaestionLibrary.quaestionLibraryAddUpdate.settingsMsg") }}</span>
                  </div>
                  <div class="section-accordion">
                    <i class="fa" :class="settingsDock ? 'fa-angle-up' : 'fa-angle-down'"></i>
                  </div>
                </div>
                <transition name="el-zoom-in-top">
                  <div class="section-wrapper" v-show="settingsDock">
                    <div class="custom-set-container" :class="form.isActive ? 'sactive' : 'spassive'">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.isActive ? 'fa-eye' : 'fa-eye-slash'"></i>
                        <div class="custom-set-info">
                          <label
                            >{{ $t("contentManagement.quaestionLibrary.quaestionLibraryAddUpdate.view") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.quaestionLibrary.quaestionLibraryAddUpdate.viewMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.isActive"></el-switch>
                      </div>
                    </div>

                    <div class="custom-set-container" :class="form.enableCustomTags ? 'sactive' : ''">
                      <div class="custom-set-inner">
                        <i class="fa" :class="form.enableCustomTags ? 'fa-tags' : 'fa-tags'"></i>
                        <div class="custom-set-info">
                          <label>
                            {{ $t("contentManagement.quaestionLibrary.quaestionLibraryAddUpdate.useTags") }}
                            <!-- <el-tooltip content="Content" placement="bottom">
                              <i class="el-icon-info"></i>
                            </el-tooltip> -->
                          </label>
                          <span>{{ $t("contentManagement.quaestionLibrary.quaestionLibraryAddUpdate.useTagsMsg") }}</span>
                        </div>
                      </div>
                      <div class="custom-set-actions fend">
                        <el-switch v-model="form.enableCustomTags"></el-switch>
                      </div>
                      <div class="custom-set-actions fcenter mt-3" v-show="form.enableCustomTags">
                        <CustomTag :value="form.customTags" :key="form.id" v-model="form.customTags"></CustomTag>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </el-col>
          </el-row>
        </el-row>
      </transition>
    </div>
    <div class="modal-footer" slot="footer" v-if="loading != 'updateQuestionItem' && form != null">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("contentManagement.quaestionLibrary.quaestionLibraryAddUpdate.close") }}</el-button>
        <template v-if="form.id != null">
          <el-popconfirm @confirm="deleteItem" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
            <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("contentManagement.quaestionLibrary.quaestionLibraryAddUpdate.delete") }}</el-button>
          </el-popconfirm>
        </template>
      </div>
      <div class="right-buttons">
        <el-button type="primary" :loading="loading == 'saveItem'" :disabled="loading == 'saveItem'" @click="save">{{ $t("contentManagement.quaestionLibrary.quaestionLibraryAddUpdate.save") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

import axios from "axios";
import ItemInfo from "./ItemInfo";
export default {
  components: { ItemInfo, quillEditor },
  name: "QuestionLibraryAddOrUpdate",
  props: ["id"],

  data() {
    return {
      settingsDock: false,
      loading: false,
      timeout: null,
      form: null,
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline", "strike"], [{ color: [] }, { background: [] }], ["clean"], ["link"]],
          syntax: {
            highlight: (text) => hljs.highlightAuto(text).value,
          },
        },
      },
      axios,
      validationErrors: [],
      showInfo: false,
    };
  },

  methods: {
    onEditorReady(editor) {
      editor.root.setAttribute("data-placeholder", this.$t("enterText"));
    },
    deleteItem() {
      this.$emit("deleteMe", this.form.id);
      this.$emit("closeDialog");
    },

    async save() {
      this.loading = "saveItem";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("questionlibrary/addorupdate", this.form);
        this.validationErrors = res.data.validationErrors;
        if (res.data.alert.hasError) {
          this.$message.error(res.data.alert.message);
        } else {
          this.$message.success(res.data.alert.message);
          this.form = res.data.data.item;
          await this.$store.dispatch("getQuestionLibrary");
        }
        this.loading = false;
      }, 500);
    },
  },

  async created() {
    this.loading = "updateQuestionItem";
    if (this.timeout != null) clearTimeout(this.timeout);
    if (this.id != undefined && this.id != null) {
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("getQuestionLibraryItem", this.id);
        if (!res.data.alert.hasError) {
          this.form = res.data.data.item;
        } else {
          this.$emit("closeMe");
        }
        this.loading = false;
      }, 500);
      this.form = this.data;
    } else {
      this.timeout = setTimeout(() => {
        this.form = {
          id: null,
          title: null,
          details: null,
          isActive: false,
          enableCustomTags: false,
          customTags: [],
          orderNO: 0,
        };
        this.loading = false;
      }, 500);
    }
  },
};
</script>
<style lang="less" scoped>
#speaker-add-new-update {
  padding: 1rem;
}
.registerform-input-container {
  .tag-container {
    gap: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .badge-list {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    .badger {
      border-radius: 8px;
      background-color: #f3f3f3;
      height: 20px;
      padding: 10px;
    }
  }
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
    label {
      font-weight: bold;
      color: black;
      margin-bottom: 0;
    }
    .title-container {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      align-items: center;
    }
  }
  display: flex;
  flex-direction: column;
  .el-input-number {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/QuestionLibraryAddOrUpdate.vue